import { useMemo } from 'react';

import { OperationsName } from '@frontend/types';

import { useOpalUser } from './useOpalUser';

export function useOperations() {
  const { opalUser } = useOpalUser();

  const operations = useMemo(() => opalUser?.instance?.operations, [opalUser?.instance]);

  const canUser = (operation: OperationsName) => {
    return operations?.find(p => p.name === operation)?.allowed;
  };

  return { operations, canUser };
}
